import BaseService from "@/services/Base-service";

class RoleService {
  get ControllerName() { return '/Role/'; }

  listRolesByCompanySectionId(companySectionId) {
    return BaseService.get(this.ControllerName + 'ListRolesByCompanySectionId/' + companySectionId);
  }

  getRolesByCompanyId(companyId) {
    return BaseService.get(this.ControllerName + 'GetRolesByCompanyId/' + companyId);
  }

  addRole(model) {
    return BaseService.post(this.ControllerName + 'CreateRole', model);
  }

  deleteRole(roleId) {
    return BaseService.post(this.ControllerName + 'DeleteRole/' + roleId);
  }

  updateRole(model) {
    return BaseService.post(this.ControllerName + 'EditRole', model);
  }

  getRole(id) {
    return BaseService.get(this.ControllerName + 'GetRole/' + id);
  }

  getPermissions() {
    return BaseService.get(this.ControllerName + 'GetPermissions');
  }

  getUsersByRole(roleId) {
    return BaseService.get(this.ControllerName + 'GetUserRoles/' + roleId);
  }

  modifyUserRoles(model, roleId) {
    return BaseService.post(this.ControllerName + 'ModifyUserRoles/' + roleId, model);
  }
}
export default new RoleService();